/**
 * Hook fetch tRPC `dashboard.meteo7j` — 168h de prévisions horaires pour le
 * siège du domaine. staleTime 30 min (aligné TTL backend), refetchOnFocus off
 * pour économiser la 4G terrain.
 */

import { useQuery } from "@tanstack/react-query";

import { trpc } from "../../../lib/trpc.js";

import { METEO_STALE_TIME_MS } from "./constants.js";

export function useMeteo7j() {
  return useQuery({
    queryKey: ["dashboard.meteo7j"],
    queryFn: () => trpc.dashboard.meteo7j.query(),
    staleTime: METEO_STALE_TIME_MS,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}
